import { render } from "./imgLayout.vue?vue&type=template&id=629e4054"
import script from "./imgLayout.vue?vue&type=script&lang=js"
export * from "./imgLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__